export enum StatusRefund {
    AprovacaoPendente = 1,
    PagamentoPendente = 2,
    Pago = 3,
    Reprovado = 4,
    Cancelado = 5,
    AprovadoParcialmente = 6
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusRefund.ts